import { LoginLogoutButton } from "../components/LoginLogoutButton/LoginLogoutButton";

export const LoginPage = () => {
  return <LoginLogoutButton />;
}